// Export the native module directly
export type { HealthModuleEvents, HealthModuleInterface, UpdateFrequency } from "./module";
export { default as Health } from "./module";